import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon, FileTextIcon, ZapIcon, MapPinIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
const benefits = ['Más de 150 páginas', '6 bonus incluidos', 'Colección de referencia', '8 módulos completos', 'Acceso de por vida'];
export function HeroSection() {
  return <section className="relative w-full bg-hero overflow-hidden pt-10 md:pt-16 pb-12 px-4" data-id="element-156">
      <div className="max-w-4xl mx-auto text-center" data-id="element-157">
        {/* Kicker */}
        <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-rose font-bold tracking-[0.18em] text-xs md:text-sm mb-7 uppercase" data-id="element-158">
          ⭐ Aula Mater ⭐
        </motion.div>

        {/* Title */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="font-serif font-bold text-4xl sm:text-5xl md:text-6xl lg:text-[5rem] leading-[1.02] text-ink mb-5 uppercase tracking-tight" data-id="element-159">
          ATLAS DEL TATUAJE JAPONÉS
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-ink-soft text-base md:text-lg mt-5 max-w-2xl mx-auto leading-relaxed" data-id="element-160">
          Descubrí la historia, los símbolos, la mitología y las composiciones
          que transformaron al irezumi en una de las formas de arte corporal más
          admiradas del mundo.
        </motion.p>

        {/* Italic rose accent */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.35
      }} className="font-serif-italic text-rose text-lg md:text-2xl mt-5" data-id="element-161">
          Arte · Historia · Mitología · Composición{' '}
          <span className="text-ink/40 mx-1" data-id="element-162">—</span> Atlas Visual Premium
        </motion.div>

        {/* Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative max-w-2xl mx-auto mt-10 md:mt-14" data-id="element-163">
          <div className="absolute inset-8 bg-rose/15 blur-3xl rounded-full" data-id="element-164" />
          <div className="absolute inset-8 bg-gold/10 blur-3xl rounded-full translate-x-10" data-id="element-165" />
          <img src="https://cdn.magicpatterns.com/uploads/sUFEFMiJXnubgorCoimM3D/ebook_principal.png" alt="Atlas del Tatuaje Japonés — Ebook" className="relative z-10 w-full h-auto rounded-2xl" data-id="element-166" />
        </motion.div>

        {/* Trust pills */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.55
      }} className="flex flex-wrap items-center justify-center gap-2.5 mt-10" data-id="element-167">
          {[{
          icon: FileTextIcon,
          text: '100% PDF'
        }, {
          icon: ZapIcon,
          text: 'Acceso en 5 min'
        }, {
          icon: MapPinIcon,
          text: 'Hecho en Argentina'
        }].map((p, i) => <div key={i} className="inline-flex items-center gap-2 bg-bg-warm border border-line text-ink text-sm font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-168">
              <p.icon className="w-4 h-4 text-rose" data-id="element-169" />
              {p.text}
            </div>)}
        </motion.div>

        {/* Benefits */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.7
      }} className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-6 max-w-2xl mx-auto" data-id="element-170">
          {benefits.map((b, i) => <span key={i} className="inline-flex items-center gap-1.5 text-sm text-ink-soft" data-id="element-171">
              <CheckIcon className="w-4 h-4 text-rose" strokeWidth={3} data-id="element-172" />
              {b}
            </span>)}
        </motion.div>

        {/* CTA */}
        <motion.a href="#oferta" onClick={e => {
        e.preventDefault();
        const el = document.getElementById('oferta');
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} whileHover={{
        y: -2
      }} className="inline-flex items-center justify-center gap-2 bg-rose hover:bg-rose-deep text-white font-bold text-base md:text-lg px-12 py-5 rounded-full shadow-xl shadow-rose/30 mt-8 transition-all w-full sm:w-auto max-w-md" data-id="element-173">
          <ArrowRightIcon className="w-5 h-5" data-id="element-174" />
          QUIERO ACCEDER AHORA
        </motion.a>

        {/* Trust row */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.9
      }} className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-5 text-xs md:text-sm text-muted" data-id="element-175">
          <span className="flex items-center gap-1.5" data-id="element-176">
            <ShieldCheckIcon className="w-4 h-4 text-rose" data-id="element-177" /> Garantía 7 días
          </span>
          <span className="text-rose/30" data-id="element-178">|</span>
          <span className="flex items-center gap-1.5" data-id="element-179">
            <LockIcon className="w-4 h-4 text-rose" data-id="element-180" /> Pago seguro
          </span>
          <span className="text-rose/30" data-id="element-181">|</span>
          <span className="flex items-center gap-1.5" data-id="element-182">
            <CreditCardIcon className="w-4 h-4 text-rose" data-id="element-183" /> Mercado Pago
          </span>
        </motion.div>

        {/* Stats bar */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1,
        duration: 0.5
      }} className="mt-8 inline-flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 bg-bg-warm/70 backdrop-blur border border-line rounded-full px-6 py-3 text-sm font-medium text-ink" data-id="element-184">
          <span data-id="element-185">
            <strong className="text-rose" data-id="element-186">+XXX</strong> lectores
          </span>
          <span className="text-line" data-id="element-187">•</span>
          <span data-id="element-188">
            <strong className="text-rose" data-id="element-189">8</strong> módulos
          </span>
          <span className="text-line" data-id="element-190">•</span>
          <span data-id="element-191">
            <strong className="text-rose" data-id="element-192">6</strong> bonus
          </span>
          <span className="text-line" data-id="element-193">•</span>
          <span data-id="element-194">
            Colección <strong className="text-rose" data-id="element-195">Premium</strong>
          </span>
        </motion.div>
      </div>
    </section>;
}